import { render, staticRenderFns } from "./RowTemplate.vue?vue&type=template&id=ff85ca08&"
import script from "./RowTemplate.vue?vue&type=script&lang=js&"
export * from "./RowTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports